<script setup lang="ts">
import { Form } from "@primevue/forms";
import { useId, type Component } from "vue";

const emits = defineEmits<{
    submit: [];
}>();

defineSlots<{
    input: (props: { formId: string }) => Component;
}>();

const formId = useId();
</script>

<template>
    <Teleport to="#forms">
        <Form :id="formId" @submit="emits('submit')" />
    </Teleport>
    <slot :formId="formId" name="input"></slot>
</template>
